<button
  class="workspace-button btn btn-primary btn-block"
  type="submit"
  (click)="stopWork('production_workspace')"
>
  STOP WORK
</button>
